import type { UploadFile } from "antd/es/upload/interface";
import type { TFunction } from "i18next";

export const ALLOWED_UPLOAD_DOCUMENT_EXTENSIONS = [".pdf", ".docx"];
export const MAX_DOCUMENT_UPLOAD_BYTES = 5 * 1024 * 1024;
export const MAX_SUPPORTING_DOCUMENTS_COUNT = 5;

export type DocumentUploadValidationError = "FILE_TYPE" | "FILE_SIZE";

export function resolveDocumentUploadValidationErrorTranslation(
  t: TFunction,
  error: DocumentUploadValidationError
): string {
  const translations: Record<DocumentUploadValidationError, string> = {
    FILE_TYPE: t("recruitment.jobApplication.documents_fileTypeUploadError"),
    FILE_SIZE: t("recruitment.jobApplication.documents_fileSizeUploadError"),
  };

  return translations[error];
}

export function isAllowedDocumentUploadFileType(file: Pick<UploadFile, "name">) {
  const fileExtension = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();

  return ALLOWED_UPLOAD_DOCUMENT_EXTENSIONS.includes(fileExtension);
}

export function getDocumentUploadValidationError(
  file: Pick<UploadFile, "name" | "size" | "originFileObj">
): DocumentUploadValidationError | undefined {
  const fileSize = file.size ?? file.originFileObj?.size ?? 0;

  if (fileSize < 1 || fileSize > MAX_DOCUMENT_UPLOAD_BYTES) {
    return "FILE_SIZE";
  }

  if (!isAllowedDocumentUploadFileType(file)) {
    return "FILE_TYPE";
  }

  return undefined;
}
